<script setup>
/* Imports */
import { computed } from 'vue';

/* Analytics */
import { sendAnalyticsEvent } from '../helpers/ga/analytics.js';
import { useScreenResize } from '../composables/useScreenResize.js';

/* Helpers */
import {
  breakpoints,
} from '../helpers/mainHelpers.js';

/* Props */
const props = defineProps({
  crumbs: {
    type: Array,
    default: () => [],
  },
  analyticsData: {
    type: Object,
    default: () => {},
  },
});

/* Composables */
const { screenWidth } = useScreenResize();

const isMobileView = computed(() => screenWidth.value <= breakpoints['mobile-m']);

const showBreadcrumbs = computed(() => props.crumbs?.every((crumb) => Boolean(crumb.contentfulUrl) && Boolean(crumb.contentfulName)));

/* Handle Analytics */
// TODO: When refactoring/implementing new analytics, make sure to update the analyticsData object
// to remove the analyticsData prop and use at the component level the data which is needed for the analytics
const breadCrumbsAnalyticsEvent = (crumb) => {
  const analyticsData = {
    tealium_event: 'product_page_breadcrumb_click',
    link_type: 'text',
    product_name: window?.utag_data?.product_name || props.analyticsData.productName || '',
    event_category: 'Product Page >> Breadcrumbs',
    event_action: 'click',
    event_label: crumb?.contentfulName ?? '',
    product_sku: window?.GarminAppBootstrap?.sku,
    currency: props.analyticsData?.currency || 'NA',
  };

  sendAnalyticsEvent(analyticsData);
};

const isTruncated = computed(() => props.crumbs?.length >= 3 && isMobileView.value);

const breadcrumbSelectHandler = (contentfulName, contentfulUrl) => {
  breadCrumbsAnalyticsEvent({ contentfulName, contentfulUrl });
  if (isTruncated.value) {
    window.location.href = contentfulUrl;
  }
};

/* Computed - Breadcrumbs */
const breadcrumbs = computed(() => props.crumbs?.map(({ contentfulName, contentfulUrl }, index) => ({
  id: index,
  text: contentfulName,
  url: contentfulUrl,
  uaEvent: `Breadcrumbs, click, ${contentfulName}`,
  onClick: () => {
    breadcrumbSelectHandler(contentfulName, contentfulUrl);
  },
  onKeyDown: () => {
    breadcrumbSelectHandler(contentfulName, contentfulUrl);
  },
})));
</script>

<template>
  <g-breadcrumbs
    v-if="showBreadcrumbs"
    :truncated="isTruncated"
    :breadcrumbs.prop="breadcrumbs"
    class="app__breadcrumbs"
  />
</template>

<style lang="scss">
.app__breadcrumbs {
  display: block;
  margin: 1rem;

  @include productBreakpoint('desktop-s') {
    margin: 0 0 1rem 0;
  }

  .g__breadcrumb__collapsed select:focus-visible {
    outline: revert;
  }
}
</style>
